module.exports = __webpack_public_path__ + "img/delete-bin-2-line.39068ff2.svg";